<template>
    <div class="box">
        <div class="header-box"></div>
        <el-tabs
                v-model="editableTabsValue"
                @tab-remove="removeTab"
                @tab-click="clickTab"
                class="padding-20"
        >
            <el-tab-pane name="首页">
        <span slot="label" class="padding-20">
          <i class="iconfont iconzhuye"></i>
        </span>
            </el-tab-pane>
            <el-tab-pane
                    v-for="item in editableTabs"
                    :key="item.name"
                    :label="item.title"
                    :name="item.name"
                    closable
            ></el-tab-pane>
        </el-tabs>

        <el-breadcrumb separator-class="el-icon-arrow-right" class="bread" v-show="breadlist.length>1">
            <template v-for="(item,index) in breadlist">
                <el-breadcrumb-item :to="{ path: item.path }"> {{item.name}}</el-breadcrumb-item>
            </template>
        </el-breadcrumb>
    </div>
</template>

<script>
    import bus from "../assets/js/EventBus";

    export default {
        name: "Nav",
        data() {
            return {
                Platformlist: [
                    {
                        name: "暂无",
                        url: "#"
                    },

                ], //站点列表
                breadlist: [],
                userName: "", //用户名
                editableTabsValue: "首页", //当前页面
                editableTabs: [] //导航列表
            };
        },
        created() {
            this.editableTabsValue = this.$route.meta.name;
            bus.$on("PushPage", e => {
                if (this.editableTabs.length === 0 && e.path != "/home") {
                    let obj = {
                        title: e.name,
                        url: e.path,
                        name: e.name
                    };
                    this.editableTabs.push(obj);
                    this.editableTabsValue = e.name;
                } else {
                    for (let i = 0; i < this.editableTabs.length; i++) {
                        if (this.editableTabs[i].title === e.name) {
                            this.editableTabsValue = e.name;
                            break;
                        } else {
                            if (this.editableTabs.length - 1 === i && e.path != "/home") {
                                let obj = {
                                    title: e.name,
                                    url: e.path,
                                    name: e.name
                                };
                                this.editableTabs.push(obj);
                                this.editableTabsValue = e.name;
                            }
                        }
                    }
                }
            });
            bus.$on("Bread", e => {
                this.breadlist = e.path;
            });
            this.getUserInfo();
        },
        methods: {
            getUserInfo() {
                this.$axios
                    .get("http://api.monitor.hzjly.cn/user/GetUserInfo")
                    .then(res => {
                        let data = JSON.parse(res.data);
                        this.userName = data.results.result.username;

                        this.$axios.get("http://api.passport.hzjly.cn/Site/SiteByUserPermission", {
                            params: {}
                        })
                            .then(res => {
                                var data = res.data;
                                data = JSON.parse(data);
                                this.Platformlist = data.results.rows;
                            })
                            .catch(err => {

                            });
                    })
                    .catch(err => {

                    });
            }, //获取用户信息
            removeTab(targetName) {
                let tabs = this.editableTabs;
                let activeName = this.editableTabsValue;
                if (activeName === targetName) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === targetName) {
                            let nextTab = tabs[index + 1] || tabs[index - 1];
                            if (nextTab) {
                                activeName = nextTab.name;
                                this.$router.push(nextTab.url);
                            }
                        }
                    });
                }
                this.editableTabsValue = activeName;
                this.editableTabs = tabs.filter(tab => tab.name !== targetName);
                if (tabs.length <= 1) {
                    this.$router.push("/home");
                    this.editableTabsValue = "首页";
                }
            }, //删除导航按钮
            clickTab(targetName) {
                if (targetName.index > 0) {
                    this.$router.push(this.editableTabs[targetName.index - 1].url);
                } else {
                    this.$router.push("/home");
                }
            } //跳转
        }
    };
</script>

<style scoped>
    .box {
        width: 100%;
        height: 55px;
    }

    .header-box {
        width: 100%;
        height: 55px;
        border-bottom: 1px solid #f6f6f6;
        display: flex;
        justify-content: space-between;
    }

    .title-box,
    .title-box-2,
    .title-box_2,
    .title-box_3 {
        width: 180px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .title-box-2 {
        width: 220px;
    }

    .title-box_2 {
        width: 50px;
        margin-right: 20px;
        cursor: pointer;
    }

    .title-box_3 {
        width: 120px;
    }

    .float-right {
        float: right;
    }

    .el-dropdown-link {
        cursor: pointer;
        color: #444;
    }

    .padding-20 {
        padding: 0 20px;
        height: 41px;
    }

    >>> .el-tabs__header {
        margin: 0;
    }

    .bread {
        border-top: 1px silver solid;
        padding: 10px 15px;
        background-color: #f6f6f6
    }
</style>
